export interface ThemeState {
  userTheme: Themes
}

export enum Themes {
  "LIGTH" = "ligth",
  "DARK" = "dark",
  "GEEK" = "geek",
}
